<template>
  <div :class="$options.name" class="d-flex">
    <v-text-field
      v-if="nameFilter"
      v-model="search"
      label="Поиск по названию"
      prepend-inner-icon="search"
      flat
      clearable
      single-line
      hide-details
    />

    <v-select
      v-if="categoryFilter"
      v-model="selectedCategoriesList"
      label="Категория"
      class="ml-2"
      hide-details
      multiple
      clearable
      :items="availableCategories"
    >
      <template v-slot:selection="{ item, index }">
        <span v-if="index === 0" class="caption">
          Выбрано {{ selectedCategories.length }} категорий
        </span>
      </template>
    </v-select>

    <region-filter v-if="regionFilter" @selected="onRegionSelect" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import debounce from 'lodash/debounce';
import RegionFilter from '@/components/page/region-filter';

export default {
  name: 'search-filter',
  components: {
    RegionFilter,
  },
  props: {
    originalModule: String,
    dataTableOptions: Object,
    nameFilter: {
      type: Boolean,
      default: true,
    },
    regionFilter: {
      type: Boolean,
      default: false,
    },
    categoryFilter: {
      type: Boolean,
      default: false,
    },
    isLoading: Boolean,
    page: Number,
  },
  data: () => ({
    search: '',

    selectedCategoriesList: [],
  }),
  computed: {
    ...mapState('filters', [
      'selectedRegions',
      'selectedCategories',
      'availableCategories',
    ]),

    isSearch() {
      const sr = this.selectedRegions;
      const sc = this.selectedCategories;

      let sortBy;
      if (this.dataTableOptions) {
        // eslint-disable-next-line prefer-destructuring
        sortBy = this.dataTableOptions.sortBy;
      }

      const { search } = this;

      return !!((search && search.length) || sr.length || (sortBy && sortBy.length) || sc.length);
    },

    list() {
      const { list } = this.$store.state[this.originalModule];

      if (!this.$store.state[this.originalModule].search) {
        console.error(`Search module of ${this.originalModule} not created!`);
        return list;
      }

      const searchList = this.$store.state[this.originalModule].search.list;

      if (this.isSearch) return searchList;
      return list;
    },

    pagination() {
      const { pagination } = this.$store.state[this.originalModule];

      if (!this.$store.state[this.originalModule].search) {
        console.error(`Search module of ${this.originalModule} not created!`);
        return pagination;
      }

      const searchPagination = this.$store.state[this.originalModule].search.pagination;

      if (this.isSearch) return searchPagination;
      return pagination;
    },
  },

  watch: {
    async dataTableOptions(newData, oldData) {
      if (JSON.stringify(newData.sortBy) === JSON.stringify(oldData.sortBy)) return;

      await this.getTableList();
    },

    async page(page) {
      if (this.isSearch) {
        await this.$store.dispatch(`${this.originalModule}/search/getNextPage`, {
          page,
          ...this.getSearchParams(),
        });
      } else {
        await this.$store.dispatch(`${this.originalModule}/getNextPage`, { page });
      }
      this.updateData();
    },

    // eslint-disable-next-line func-names
    search: debounce(async function () {
      await this.viaLoading(() => this.getTableList());
    }, 750),

    // eslint-disable-next-line func-names
    selectedCategoriesList: debounce(async function (categories) {
      await this.syncCategories(categories);
      await this.getTableList();
    }, 750),
  },

  async created() {
    await this.getTableList();
  },

  methods: {
    ...mapActions('filters', ['syncCategories']),

    async viaLoading(cb) {
      this.$emit('update:is-loading', true);
      await cb();
      this.$emit('update:is-loading', false);
    },

    getSearchParams() {
      const { sortBy, sortDesc } = this.dataTableOptions;
      const params = { sortBy, sortDesc };
      if (this.search && this.search.length) {
        params.query = this.search;
      }
      if (this.selectedRegions && this.selectedRegions.length) {
        params.regionIds = this.selectedRegions;
      }

      if (this.selectedCategories && this.selectedCategories.length) {
        params.categoryIds = this.selectedCategories;
      }

      return params;
    },

    async getTableList(page = null) {
      if (this.isSearch) {
        const params = this.getSearchParams();
        if (page === null) {
          await this.$store.dispatch(`${this.originalModule}/search/getList`, params);
        } else {
          params.page = page;
          await this.$store.dispatch(`${this.originalModule}/search/getNextPage`, params);
        }
      } else {
        this.dataTableOptions.sortBy = [];
        this.dataTableOptions.sortDesc = [];
        if (page === null) {
          await this.$store.dispatch(`${this.originalModule}/getList`);
        } else {
          await this.$store.dispatch(`${this.originalModule}/getNextPage`, { page });
        }
      }
      this.updateData();
    },

    onRegionSelect() {
      this.viaLoading(async () => {
        await this.getTableList();
      });
    },

    updateData() {
      this.$emit('input', {
        list: this.list,
        pagination: this.pagination,
        isSearch: this.isSearch,
      });
    },
  },
};
</script>

<style scoped>

</style>
